import styled from 'styled-components';

export const MainWrapper = styled.div`
    position: relative;
`;
